import { getClientLanguage } from '@/lib/get-client-language';

function getCurrencyConfiguration(currencyCode: string) {
  const fiatFormat: Intl.NumberFormatOptions = {
    useGrouping: true,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  };
  const cryptoFormat: Intl.NumberFormatOptions = {
    useGrouping: true,
    maximumFractionDigits: 9,
    minimumFractionDigits: 9,
  };
  const cryptoFormatInteger: Intl.NumberFormatOptions = {
    useGrouping: true,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  };
  const luckyBLock: Intl.NumberFormatOptions = {
    useGrouping: true,
    compactDisplay: 'short',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  };

  const currencyFormatConfigurations: Record<string, Intl.NumberFormatOptions> = {
    default: fiatFormat,

    EUR: fiatFormat,
    USDT: fiatFormat,
    USD: fiatFormat,
    JPY: fiatFormat,
    BTC: cryptoFormat,
    ETH: cryptoFormat,
    ADA: cryptoFormat,
    BCH: cryptoFormat,
    LTC: cryptoFormat,
    DOGE: cryptoFormat,
    XRP: cryptoFormat,
    BNB: cryptoFormat,
    TRX: cryptoFormat,
    DAI: cryptoFormat,
    NEO: cryptoFormat,
    USDC: cryptoFormat,
    BRZ: cryptoFormat,
    CSC: cryptoFormat,
    BUSD: cryptoFormat,
    SNCK: cryptoFormat,
    EURS: cryptoFormat,
    XED: cryptoFormat,
    WBTC: cryptoFormat,
    LBCK: luckyBLock,
    SOL: cryptoFormat,
    AVAX: cryptoFormat,
    LINK: cryptoFormat,
    MTIC: cryptoFormat,
    DOT: cryptoFormat,
    UNI: cryptoFormat,
    SHIB: cryptoFormatInteger,
    BABY: cryptoFormat,
    WSM: cryptoFormat,
  };
  if (!currencyCode) return currencyFormatConfigurations.default;
  return currencyFormatConfigurations[currencyCode] ?? currencyFormatConfigurations.default;
}

export function formatCurrency(currencyCode: string, balance: number) {
  const numberFormatter = new Intl.NumberFormat(getClientLanguage(), getCurrencyConfiguration(currencyCode));
  return numberFormatter.format(balance);
}

export function formatCurrencyWithLabel(currencyCode: string, balance: number) {
  try {
    const formatter = new Intl.NumberFormat(getClientLanguage(), {
      ...getCurrencyConfiguration(currencyCode),
      style: 'currency',
      currency: currencyCode,
    });
    return formatter.format(balance);
  } catch {
    const numberFormatter = new Intl.NumberFormat(getClientLanguage(), getCurrencyConfiguration(currencyCode));
    return `${currencyCode} ${numberFormatter.format(balance)}`;
  }
}
